import { IdNameDto } from '@app/store/shared/models';

export class MaterialLookup {
    readonly id: string;
    readonly name: string;

    constructor(dto: IdNameDto) {
        this.id = dto.id;
        this.name = dto.name;
    }
}
